var initialTorusWalletControllerState = {
    ethersProvider: null,
    torusAddress: undefined,
    torusChainId: undefined,
};
export default initialTorusWalletControllerState;
